(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@agm/core')) :
	typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@agm/core'], factory) :
	(factory((global['agm-direction'] = {}),global.core,global.core$1));
}(this, (function (exports,core,core$1) { 'use strict';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AgmDirection = (function () {
    function AgmDirection(gmapsApi) {
        this.gmapsApi = gmapsApi;
        this.travelMode = 'DRIVING';
        this.transitOptions = undefined;
        this.drivingOptions = undefined;
        this.waypoints = [];
        this.optimizeWaypoints = true;
        this.provideRouteAlternatives = false;
        this.avoidHighways = false;
        this.avoidTolls = false;
        this.visible = true;
        this.onChange = new core.EventEmitter();
        this.directionsService = undefined;
        this.directionsDisplay = undefined;
    }
    /**
     * @return {?}
     */
    AgmDirection.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.directionDraw();
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    AgmDirection.prototype.ngOnChanges = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        /**
             * When visible is false then remove the direction layer
             */
        if (!this.visible) {
            try {
                this.directionsDisplay.setPanel(null);
                this.directionsDisplay.setMap(null);
                this.directionsDisplay = undefined;
            }
            catch (/** @type {?} */ e) { }
        }
        else {
            /**
                   * When renderOptions are not first change then reset the display
                   */
            if (obj.renderOptions) {
                if (obj.renderOptions.firstChange === false) {
                    this.directionsDisplay.setPanel(null);
                    this.directionsDisplay.setMap(null);
                    this.directionsDisplay = undefined;
                }
            }
            this.directionDraw();
        }
    };
    /**
     * This event is fired when the user creating or updating this direction
     * @return {?}
     */
    AgmDirection.prototype.directionDraw = /**
     * This event is fired when the user creating or updating this direction
     * @return {?}
     */
    function () {
        var _this = this;
        this.gmapsApi.getNativeMap().then(function (map) {
            if (typeof _this.directionsDisplay === 'undefined') {
                _this.directionsDisplay = new google.maps.DirectionsRenderer(_this.renderOptions);
                _this.directionsDisplay.setMap(map);
            }
            if (typeof _this.directionsService === 'undefined') {
                _this.directionsService = new google.maps.DirectionsService;
            }
            if (typeof _this.panel === 'undefined') {
                _this.directionsDisplay.setPanel(null);
            }
            else {
                _this.directionsDisplay.setPanel(_this.panel);
            }
            _this.directionsService.route({
                origin: _this.origin,
                destination: _this.destination,
                travelMode: _this.travelMode,
                transitOptions: _this.transitOptions,
                drivingOptions: _this.drivingOptions,
                waypoints: _this.waypoints,
                optimizeWaypoints: _this.optimizeWaypoints,
                provideRouteAlternatives: _this.provideRouteAlternatives,
                avoidHighways: _this.avoidHighways,
                avoidTolls: _this.avoidTolls,
            }, function (response, status) {
                if (status === 'OK') {
                    _this.directionsDisplay.setDirections(response);
                    /**
                               * Emit The DirectionsResult Object
                               * https://developers.google.com/maps/documentation/javascript/directions?hl=en#DirectionsResults
                               */
                    /**
                     * Emit The DirectionsResult Object
                     * https://developers.google.com/maps/documentation/javascript/directions?hl=en#DirectionsResults
                     */
                    _this.onChange.emit(response);
                }
            });
        });
    };
    AgmDirection.decorators = [
        { type: core.Directive, args: [{
                    selector: 'agm-direction'
                },] },
    ];
    /** @nocollapse */
    AgmDirection.ctorParameters = function () { return [
        { type: core$1.GoogleMapsAPIWrapper, },
    ]; };
    AgmDirection.propDecorators = {
        "origin": [{ type: core.Input },],
        "destination": [{ type: core.Input },],
        "travelMode": [{ type: core.Input },],
        "transitOptions": [{ type: core.Input },],
        "drivingOptions": [{ type: core.Input },],
        "waypoints": [{ type: core.Input },],
        "optimizeWaypoints": [{ type: core.Input },],
        "provideRouteAlternatives": [{ type: core.Input },],
        "avoidHighways": [{ type: core.Input },],
        "avoidTolls": [{ type: core.Input },],
        "renderOptions": [{ type: core.Input },],
        "visible": [{ type: core.Input },],
        "panel": [{ type: core.Input },],
        "onChange": [{ type: core.Output },],
    };
    return AgmDirection;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AgmDirectionModule = (function () {
    function AgmDirectionModule() {
    }
    /**
     * @return {?}
     */
    AgmDirectionModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: AgmDirectionModule,
        };
    };
    AgmDirectionModule.decorators = [
        { type: core.NgModule, args: [{
                    imports: [],
                    declarations: [
                        AgmDirection,
                    ],
                    exports: [
                        AgmDirection,
                    ]
                },] },
    ];
    /** @nocollapse */
    AgmDirectionModule.ctorParameters = function () { return []; };
    return AgmDirectionModule;
}());

exports.AgmDirectionModule = AgmDirectionModule;
exports.AgmDirection = AgmDirection;

Object.defineProperty(exports, '__esModule', { value: true });

})));



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/agm-direction/agm-direction.umd.js.pre-build-optimizer.js